import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import iconPdf from '../../../../static/icons/icon-pdf.png';
import * as styles from '../UploadAssetWidget.scss';

const RotatedImagePreview = ({ id, angle, isRaw, image, onImageError }) => (
  <div
    id={`rotated_image_${id}`}
    className={cx(styles.images, 'upload-img')}
    style={{ transform: `rotate(${angle}deg)` }}
  >
    <img
      src={isRaw ? iconPdf : image}
      alt=""
      onError={onImageError}
      style={{ objectFit: 'cover' }}
    />
  </div>
);

RotatedImagePreview.propTypes = {
  id: PropTypes.string,
  angle: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isRaw: PropTypes.bool,
  image: PropTypes.string,
  onImageError: PropTypes.func.isRequired
};

export default RotatedImagePreview;
